import React, { useEffect, useState } from "react";
import { Table, Spin, Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { EllipsisOutlined } from "@ant-design/icons";

import NestedTable from "../../../components/NestedTable/NestedTable";
import styles from "./TrayList.module.css";
import { useTranslation } from "react-i18next";

const TrayListTable = ({
  site,
  device,
  ordersList,
  selectedOrder,
  setSelectedOrder,
  isProcessingAction,
  resetTray,
  deleteTray,
}) => {
  const { t } = useTranslation("trupakTrayList")

  const navigate = useNavigate();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  useEffect(() => {
    setExpandedRowKeys(
      selectedOrder ? [selectedOrder.dispensingOrder._id] : []
    );
  }, [selectedOrder]);

  const columns = [
    {
      title: t("orderCol"),
      render: (order) => order.dispensingOrder.dispensingOrderId,
    },
    {
      title: t("deviceCol"),
      render: (order) => order.dispensingOrder.routedToName,
    },
    {
      align: "center",
      title: t("facilityCol"),
      render: (order) => order.dispensingOrder.facility.name,
    },
  ];

  const childTable = () => (
    <Table
      bordered
      rowKey="_id"
      pagination={false}
      dataSource={selectedOrder?.trayChecks || []}
      columns={[
        {
          title: t("traySeqCol"),
          render: (row) =>
            `${row.rangeId}${
              selectedOrder && selectedOrder.trayNeeds
                ? ` ${t("ofLabel")} ${selectedOrder.trayNeeds.totalTrays}`
                : ""
            }`,
        },
        {
          title: t("trayCol"),
          render: (row) => row.assignedTrayId,
        },
        {
          align: "center",
          title: t("trayStatusCol"),
          render: (row) => t(row.status, {ns: "trayStatuses"}),
        },
        {
          width: 10,
          align: "center",
          title: t("actionsCol"),
          onCell: (_) => {
            return {
              onClick: (e) => e.stopPropagation(),
            };
          },
          render: (row) =>
            isProcessingAction ? (
              <Spin size="small" />
            ) : (
              <Dropdown
                trigger={["click"]}
                menu={{
                  items: [
                    {
                      key: "reset-option",
                      disabled: row.status === "Ready",
                      label: t("resetAction"),
                    },
                    {
                      key: "delete-option",
                      label: t("deleteAction"),
                    },
                  ],
                  onClick: async ({ key, domEvent }) => {
                    domEvent.preventDefault();
                    if (key === "reset-option") {
                      await resetTray(row);
                    } else if (key === "delete-option") {
                      await deleteTray(row);
                    }
                    setExpandedRowKeys([]);
                  },
                }}
              >
                <EllipsisOutlined style={{ padding: "5px 10px" }} />
              </Dropdown>
            ),
        },
      ]}
      rowClassName={(record) =>
        record.approved
          ? record.status.toUpperCase() === "CORRECTED APPROVED"
            ? styles.CorrectedApprovedRow
            : styles.ApprovedRow
          : record.slots.some((slot) =>
              slot.drugs.some(
                (drug) =>
                  drug.approvalType &&
                  drug.approvalType.toUpperCase() === "CORRECTED APPROVED"
              )
            )
          ? styles.CorrectedApprovedRow
          : record.status.toUpperCase() === "NOT FILLED"
          ? styles.NotFilledRow
          : styles.NeedCheckRow
      }
      onRow={(record, _) => {
        return {
          onClick: (_) => {
            if (
              !record.isLocked &&
              (!record.approved ||
                (record.approved &&
                  record.slots.some((slot) =>
                    slot.drugs.some(
                      (drug) =>
                        drug.approvalType &&
                        drug.approvalType.toUpperCase() === "CORRECTED APPROVED"
                    )
                  )))
            ) {
              navigate(
                `/site/${site._id}/device/${device._id}/order/${record.dispensingOrder._id}/trayCheck/${record._id}`
              );
            }
          },
        };
      }}
    />
  );

  return (
    <NestedTable
      data={ordersList}
      columns={columns}
      childTable={childTable}
      expandedRowKeys={expandedRowKeys}
      onRowContract={() => setSelectedOrder(null)}
      rowKey={(record) => record.dispensingOrder._id}
      onRowExpand={(order) => setSelectedOrder(order)}
      rowClassName={(record) =>
        record.trayChecks.some((item) => !item.approved)
          ? record.trayChecks.some(
              (item) => item.status.toUpperCase() === "NOT FILLED"
            )
            ? styles.NotFilledRow
            : record.trayChecks.some((item) =>
                item.slots.some((slot) =>
                  slot.drugs.some(
                    (drug) =>
                      drug.approvalType &&
                      drug.approvalType.toUpperCase() === "CORRECTED APPROVED"
                  )
                )
              )
            ? styles.CorrectedApprovedRow
            : styles.NeedCheckRow
          : record.trayChecks.some(
              (item) => item.status.toUpperCase() === "CORRECTED APPROVED"
            )
          ? styles.CorrectedApprovedRow
          : record.trayChecks.length < record.trayNeeds.totalTrays
          ? styles.NeedCheckRow
          : styles.ApprovedRow
      }
    />
  );
};

export default TrayListTable;
